module.exports = {
    language: {
        "5o6u1gm1kjhg":"User Menu Resources",
        "5o6u1gm1k1hg": "User Data Resources",
        "5o6u1gm4k4hs": "Please select the user to export",
        "5o6u1gm4k4ha": "If it is beyond the scope of system support, please contact the person in charge of the system",
        "5o6u1gm4k4ba": "Menu Resources ",
        "5o6u1gm4kjhg": 'null',
        "5o6u1gm4k4hg": 'Accurate query',
        "5o6u1dm4kjhg": 'Batch download',
        "5o1u1gm4kjhg": 'Batch query',
        "5o6u1g74kjhg": 'Cross warehouse query',
        "5o6u1gm4k0hg": 'Personal privacy type',
        "5o6u1ga4kjhg": 'Personal privacy type (internal)',
        "5o6u1gm4kshg": 'Merchant type',
        "1o6u1gm4kjhg": 'Financial type',
        "5o6u1gm4kahg": 'Sales type',
        "5o6u1g84kjhg": 'Contract type',
        "5o6u1gm4kj4g": 'Operational risk type',
        "5o6u1gm4kjh1": "Public Library",
        "526u1gm4kjhg": "Merchant workbench library",
        "5o6v4bolg4w2": "JD employee ERP account",
        "5o6v4bo1g4w1": "JD PIN account",
        "5o6v4bolg4wm": "Account number of supply chain industry platform",
        "5o6v4bolg4s1": "Special account for multi-tenant framework",
        "5o6v4bowg4w1": "Cloud warehouse account",
        "5o6u1gm44xk9": "Mobile phone number format error", 
        "5o6u1gml4xk9": "Close all", 
        "5o6u1gml4ik9": "Permission system", 
        "5o6u1gml4kk9": "Switch tenants", 
        "5o6usgml4ik9": "Select Tenant",
        "5o6usgmk4ik9": "Log off",
        "5o9usgmk4ik9": "Frequently Asked Questions",
        "5o9usgmm4ik9": "Help Document",
        "5o6v4bolg4w1": "Tenant Code",
        "5o6v4bokg4w0": "Please enter the tenant code",
        "5o6v4bovg4w0": "Tenant Name",
        "5o6v4bolg4q0": "Please enter the tenant name",
        "5o6v4bolg4qf": "Loading...",
        "5o6v4bolg1q0": "There are no more tenants",
        "5o6v4bolg1l0": "The tenant has switched to",
        "5o6v4bo2g1l0": "Product User Manual, Interface Document",
        "5o6v4bolg190": "You can check it here in the future",
        "5o6v4bolg19a": "Batch Maintenance Management Permission",
        "5o6v4bolg19s": "The maximum number of imported files is 5000",
        "5o6v4bolg120": "Switch new version",
        "5o6v4bolg12s": "The user has been deactivated!",
        "5o6v4bole12s": "Home page",
        "5o6v4bolr12s": "Total",
        "5o6u1qna4xqw": "Extended field",
        "5o6u1qla4xqw": "Learn more",
        "5o6u1qna4jqw": "I know",
        "5o6u1qnajxqw": "System capability upgrade!",
        "5oju1qns4xqw": "In order to meet the personalized permission control requirements of the business, currently USF supports business parties to customize and develop based on standard capabilities. Any personalized logic that meets the business scenario can be customized. We sincerely invite you to use it!",
        "5o6u1qns4xqj": "Scenarios currently supporting customized development:",
        "5oju1qvs4xqw": "Configurable verification rules when adding users;",
        "5o6u1qns4xqh": "Configurable verification rules when users allocate data resources;",
        "5o6u1qka4qkd": "Permission application approval result message can be customized;",
        "5o6u1qkr4qkd": "Customize the display content of the permission application approval form.",
        "5o6u1qkr4qkq": "More demand feedback",
        "5o6u1qkr4qkc": "Team",
        "5o5ve68s8r40": "Confirm to delete the selected",
        "5o5ve68s5r40": "Are you sure to delete the selected data resource",
        "5o6ve68h8r40": "What",
        "5o6u1qna4xq0": "Business Permission",
        "5o6u1qna4xqk": "USF Permission",
        "5o6u1qna4xqd": "Platform Management",
        "5o6u1qna4aqd": "Organization management",
        "5o6u1qka4xqd": "Organization Permission",
        "5o6u1qka4qqd": "piece",
        "5o6u1qka4qql": "Enter keywords to search for documents",
        "5o6u1qko4qql": "Home page",
        "5o6u1qko41ql": "Error",
        "5o6u1qko4qsl": "Log out", 
        "5o6u1qna4xk0": "Please select a role",
        "5o6u1sna4xk0": "Please select the role to delete",
        "5o6u1qna9xk0": "The role has been assigned",
        "5o6u1qn44xk0": "Are you sure to delete this role?",
        "5o6u1qm44xk0": "Are you sure to delete the data role?",
        "5o6u1gm44xk0": "Please enter the activity name",
        "5o6ukqm44xk0": "Please select active area",
        "5o6ukqm44hk0": "Type code length cannot exceed 30 characters",
        "5o6ukqm44hb0": "Field name can be up to 10 characters",
        "5o6ukqm44hl0": "Only numbers, letters, underscores and Chinese are allowed for field names",
        "5o6ukqm44hko": "Enumeration value with type code length no more than 3 can enter 500 characters at most",
        "5o6uhqm44hk0": "Extra comma is not allowed at the end of enumeration value",
        "5o6ukqmi4hk0": "Enumerated values need to appear in the format: Display Value: Value. English colon and comma are separators. In addition to the separator, you can enter numbers, letters, underscores, and Chinese",
        "5o6uh9m44hk0": "key or value cannot be empty",
        "5o6uhqm4yhk0": "Duplication is not allowed",
        "5o6uhqm44hl0": "Key value of enumeration value",
        "5o6uhqm4phl0": "The value of the enumeration value",
        "5o6uhum4phl0": "I have filled it in. Next step",
        "5o6uhuk4phl0": "data import failed",
        "5o6umuk4phl0": "After deleting this role, the user who originally owned this role may lose the corresponding permissions of the role",
        "5o6lhuk4phl0": "Other users are currently submitting for processing",
        "5o6uhukiphl0": "the dialog box will automatically close after seconds",
        "5o6uhukiuhl0": "Please enter Chinese, English, numbers, -, _ {、:、/、#、$、}",
        "5o6uhukipfl0": "Sensitive data type",
        "5o6uhukipal0": "Software resource custom fields",
        "5o6uhukipai0": "The length of menu name cannot exceed 50 characters",
        "5o6phukipal0": "Menu coding supports Chinese, English, numbers, -, _ {、:、/、#、$、}",
        "5o6uhupipal0": "The menu code shall not exceed 50 characters",
        "5oouhukipal0": "Menu code already exists, please rename it",
        "5oouhukiwal0": "The length of the domain name cannot exceed 400 characters",
        "5oouhubipal0": "The format of the domain name is incorrect",
        "5oouhuki4al0": "Icon length cannot exceed 50 characters",
        "5uouhuki4al0": "Please enter the menu serial number",
        "5oouhuki4au0": "Menu serial number already exists, please re-enter",
        "5o6u1qna4po0": "Please select a parent node",
        "5o6u1qnalxo0": "This resource has been associated with a menu role. After the change, the parent resource of the unassociated role will be associated with it. Do you want to continue?",
        "5o6u1qnapxk0": "Operation succeeded",
        "5o6u1qna4qk0": "Role",
        "5o6umqnapxk0": "User group",
        "5o6umqnaqxk0": "User",
        "5o6umqnapyk0": "Distribution",
        "5o6umqnaphk0": "Click OK to delete the user group",
        "5o6umqna9yk0": "User group code only supports Chinese, English, numbers, -, _, .",
        "5o6uqqna9yk0": "User group code length cannot exceed 80 characters",
        "5o61qqna9yk0": "The length of user group name cannot exceed 80 characters",
        "5o61qqna8yk0": "Assign data roles",
        "5o61lqna8yk0": "View data roles",
        "5o61qqna7yk0": "Data Role",
        "5o61qqnahyk0": "Import user groups",
        "5o61qqnasyk0": "Import User Group Menu Role",
        "5o61qqnalyk0": "Import user group data role",
        "5o617qnalyk0": "No data",
        "5o617qnaly20": "Export details",
        "5o6s7qnalyk0": "Due to the large amount of data to be exported this time, the export results will be sent by thump/email within 24 hours. Please check.",
        "5o6177naly20": "Exporting",
        "5o617mnaly20": "Department",
        "5o617mnply20": "Dost",
        "5o617mnply80": "Special for village/neighborhood committee",
        "5o617mnply10": "The user type is only used for user identification and cannot be assigned administrator permissions.",
        "5o617mnply11": "Please input a password",
        "5o617mn9ly11": "Account number does not exist",
        "5o617mu9ly11": "Are you sure to authorize all data permissions to the selected user?",
        "5o617mu0ly11": "Wether large field",
        "5o6ukqm14hko": "Enumeration value can be entered up to 200 characters",
        "5o6ukqm14iko": "Enumeration or large field is not allowed",
        "5o6ukqm14imo": "Note: A single import cannot exceed 10000 pieces. If it exceeds the limit, please upload in batches or select mass import",
        "5o6ukqm1gimo": "Reset Password",
        "5o6ukq114imo": "Reset mobile phone number",
        "5o6ukql14imo": "Reset mailbox",
        "5o6ukqlf4imo": "Confirm mobile phone number",
        "5o6akql14imo": "Please enter your mobile number again",
        "5o6akql10imo": "Confirm email",
        "5oeakql14imo": "Please enter the mailbox again",
        "5oeakql14im7": "The phone number entered twice is inconsistent",
        "5oeakql14mm7": "The two input mailboxes are inconsistent",
        "5oeakql17mm7": "contains at least two combinations of letters, numbers and characters, and the number of digits is between 8-20",
        "5oeakql17mm1": "Operation",
        "5orakql17mm1": "The user has access to the data resource from the following channels. If you want to remove the user's access to the data resource, you need to remove all users from the following channels",
        "5oeakql11mm1": "After enabling, all permissions of the selected user will be restored. Are you sure to enable?",
        "5oeak2l17mm1": "Confirm enabling",
        "5oeakql17pm1": "After disabling, the selected user will lose all permissions. Are you sure to disable?",
        "5oeakblm7mm1": "After deactivation, the user will lose all permissions and cannot log in to any system",
        "5oeakqlm7mm2": "After enabling, the user will recover all permissions and be able to log in and use the system normally",
        "5oeakqlm7km1": "After enabling, the user will recover all permissions",
        "5oeakqlm7vm1": "Are you sure to disable this user?",
        "5oeakqlm8mm1": "Are you sure to enable this user?",
        "5oeakqlm7mm1": "Confirm deactivation",
        "5oeakqlm7om1": "User information",
        "5oeakqlm7om9": "Export failed",
        "5oeakqlmlom9": "Export failed! Please re-export. If there is still no result, please contact USF Xiaomei (org. missusf)",
        "5o6u3wttklw0": "Data resource code",
        "5o6u3sttkdw0": "Reason for allocation failure",
        "5o6u3wttkgw0": "User failed to allocate data resources",
        "5oku3wttkgw0": "Line breaks are not allowed",
        "5oku3wttkgl0": "Import organization information",
        "5oku3wttqgl0": "Institution related posts",
        "5oku3wttqal0": "Organization",
        "5oku3wttqal9": "Please select an organization first!",
        "5oku3wttqag9": "Please keep at least one display field",
        "5oku3wttqsg9": "Exporting, please wait",
        "5oku3wttqsg5": "Chinese",
        "5oku3wttqsl9": "English",
        "5oku3wttqsl1": "Please select a language",
        "5o6u1qna4xo0": "Before operation",
        "5o6u1qna53c0": "After operation",
        "5o6u3wttipk0": "Application coding",
        "5o6u3wtti1k0": "If Zhang San assigns apples to Li Si, then the operator is Zhang San, the object of operation is Apple, and the object of operation is Li Si",
        "5o6u3w5ti1k0":"Please enter the operator",
        "5o6u3w5ti190": "View content",
        "5o6u3w5tm190": "Application management",
        "5o6l3wttjuo0": "Show enterprises only",
        "5o6u3wvtjxs0": "Show departments only",
        "5o6j3w5tm190":"Please enter the organization code",
        "5o6u3wttvb00":"Whether you have administrative authority",
        "5o6u3wttgb00":"Sales platform name",
        "5o6u3wtfvb00":"Domain name of sales platform",
        "5o6u3cttvb00":"Account number",
        "5o6u3rttvb00":"Please enter account/alias/name",
        "5o6u3rttbb00":"Alias",
        "5o6u3rttvbh0":"Show organization only",
        "5o6u3rtvvb00":"Expand more",
        "5o6u3rtuvb00":"There are too many sub-nodes. The first 300 nodes are displayed. Please query the nodes that are not displayed!",
        "5o6u3rtuvv00":"Organization",
        "5o6u3wttjs00": "Please select at least one item to set",
        "5o6u3wttjsv0": "Only the super administrator can be set for the organization, but not for the department. After the super administrator is set, the user will have the management authority of all data, roles and departments under the organization",
        "5o6u3wttjsw0": "Operation failed",
        "5o6u3wttjm00": "Operated object code",
        "5o6u3wttjrg0": "Operated object name",
        "5o6u3wttjuo0": "Business type",
        "5o6u3wttjxs0": "Operation type",
        "5o6u3wttk1c0": "Operation object code",
        "5o6u3wttk4o0": "Operation object name",
        "5o6u3wttk7o0": "Operation content",
        "5o6u3wttkb00": "Operation path",
        "5o6u3wttkdw0": "Operator",
        "5o6u3wttkgk0": "Operation time",
        "5o6u3wttk6k0": "Please enter the code",
        "5o6u3wttk3k0": "Please select  business type",
        "5o6u3ottk6k0": "Please select operation type",
        "5o6uwcyxcbk0": "Sensitive identification",
        "5o6uwcyxcls0": "Whether can be null",
        "5o6v3nds2ns0": "Unified permission system",
        "5o6vnf9ryxc0": "Set successfully",
        "5o6vnf9rx200": "Apply name",
        "5o6w90h4lws0": "Domain name",
        "5o6w90h4mao0": "Process ID",
        "5o6w90h4me80": "Application manager",
        "5o6w90h4mhc0": "application manager's erp",
        "5o6w90h4mr80": "Please select the application to be configured!",
        "5o6w90h4n700": "Only one application can be selected for configuration",
        "5o6wc500n340": "New",
        "5o6wc500ng20": "Please enter the warehouse number",
        "5o6wc500ng30": "New data resources",
        "5o6wc500ng40": "Please enter the warehouse name",
        "5o6wc500ngo0": "The length cannot exceed 30 characters",
        "5o6wbevi5u00": "Please enter the data resource code starting with data",
        "5o6wazk04rw0": "Import data resources",
        "5o6wazk04u80": "No field",
        "5o6wazk04x80": "Data resource code",
        "5o6wazk054w0": "Please select data first",
        "5o6wazk057c0": "No fields are enabled for this data type",
        "5o6wak4kg480": "Data resources",
        "5o6wak4kgko0": "Export exception, please contact USF operator",
        "5o6wak4kgog0": "Export request failed",
        "5o6vkto5xjo0": "Confirm",
        "5o6vkto5ycw0": "Affiliated system",
        "5o6vkto5yks0": "Please enter English, numbers, _, -",
        "5o6vkto5yvg0": "Whether required field",
        "5o6vkto5z640": "Please separate them with English commas",
        "5o6vkto5z8k0": "Whether unique identification",
        "5o6vkto5zb80": "Whether display name",
        "5o6vkto5zdk0": "Please enter type code",
        "5o6vkto5zgc0": "Type code supports English, numbers, -, _",
        "5o6vkto5zkg0": "The type code already exists",
        "5o6vkto5zmk0": "Please contact the administrator",
        "5o6vkto5zow0": "Please enter type name",
        "5o6vkto5zr40": "The length of type name cannot exceed 40 characters",
        "5o6vkto5ztc0": "The type name already exists",
        "5o6vkto5zv80": "Please select the system",
        "5o6vkto5zyw0": "There must be a required field",
        "5o6vkto600s0": "Please enable extended fields in turn",
        "5o6vkto602w0": "Please fill in the enabled field name",
        "5o6vkto604k0": "Enumeration value of enumeration type cannot be null",
        "5o6vk82zm180": "Type code",
        "5o6vk82zm540": "Type name",
        "5o6vk82zmpg0": "Please select the data to view!",
        "5o6vk82zmrw0": "Only one data can be selected for viewing!",
        "5o6vh54a0g40": "User's Alias",
        "5o6vg67fm240": "Approval process ID",
        "5o6vg67fm4k0": "The approval ID can be obtained after the approval process is configured on the approval platform.",
        "5o6vg67fm740": "View operating description",
        "5o6vg67fm9g0": "Whether can apply",
        "5o6vg67fmbw0": "Role description",
        "5o6vg67fmes0": "The role description will be displayed on the permission application page to avoid the applicant not knowing which roles to apply for",
        "5o6vg67fmm40": "Role name cannot be empty",
        "5o6vg67fmog0": "The length of the role name cannot exceed 80 characters",
        "5o6vg67fneo0": "Role code cannot be empty",
        "5o6vg67fnms0": "The supported characters are as follows: Chinese and English numbers - . _ = + # ()（）&",
        "5o6vg67fnqk0": "The role code length cannot exceed 80 characters",
        "5o6vg67fntc0": "The note length cannot exceed 120 characters",
        "5o6vg67foac0": "Cannot be empty",
        "5o6vg67foic0": "Resource name",
        "5o6vg67folw0": "Resource code",
        "5o6vg67foo80": "Resource type",
        "5o6vg67foqc0": "Sensitive identification",
        "5o6vg67foso0": "The role already exists, please re-enter!",
        "5o6veotsluc0": "Export",
        "5o6veotsmas0": "Export menu role",
        "5o6veotsmeo0": "Export user menu roles",
        "5o6veotsmhk0": "Menu role name",
        "5o6veotsmk40": "Menu role code",
        "5o6ve68s7yc0": "Custom module",
        "5o6ve68s8i40": "Import",
        "5o6ve68s8m40": "Please select at least one item to assign",
        "5o6ve68s8oo0": "Only one item can be selected for allocation",
        "5o6ve68s8r40": "Please select at least one item to delete",
        "5o6ve68s8ts0": "Only one item can be selected for deletion",
        "5o6ve68s8wg0": "Please select at least one item to display",
        "5o6ve68s8ys0": "Only one item can be selected for display",
        "5o6ve68s91g0": "Please select at least one item to edit",
        "5o6ve68s93w0": "Only one item can be selected for editing",
        "5o6ve68s9680": "This role has been assigned to users. Please disassociate before deleting",
        "5o6ve68s98s0": "This role has been assigned to users/institutions. Please disassociate before deleting",
        "5o6ve68s9bg0": "This role has been assigned to users/user groups. Please disassociate before deleting",
        "5o6ve68s9dw0": "This role has been assigned to users/user groups/organizations. Please disassociate before deleting",
        "5o6ve68s9gc0": "his role has been assigned to the organization. Please disassociate before deleting",
        "5o6ve68s9io0": "This role has been assigned to user group/organization. Please disassociate before deleting",
        "5o6ve68s9lo0": "The role has been assigned to the user group. Please disassociate before deleting",
        "5o6ve68s9o00": "Are you sure to delete the selected menu role",
        "5o6v4bole4o0": "Move Up",
        "5o6v4bolesg0": "Move Down",
        "5o6v4bolf5k0": "Whether sensitive resource",
        "5o6v4bolfsc0": "Field SN",
        "5o6v4bolfv40": "Whether enable",
        "5o6v4bolfxo0": "Whether required",
        "5o6v4bolg0c0": "Field name",
        "5o6v4bolg340": "Whether enumerate types",
        "5o6v4bolg5s0": "Enter enumeration value",
        "5o6v4bolg8s0": "Please select the data to delete!",
        "5o6v4bolgcc0": "Only one data can be selected for deletion!",
        "5o6v4bolggs0": "The root menu cannot be deleted!",
        "5o6v4bolgjc0": "Please select the data to edit!",
        "5o6v4bolglk0": "Only one data can be selected for editing!",
        "5o6v4bolgnk0": "The root menu cannot be edited!",
        "5o6v4bolgpk0": "Please select the data to be changed!",
        "5o6v4bolgrk0": "Only one data can be selected for change!",
        "5o6v4bolgtk0": "The root menu cannot be changed!",
        "5o6v4bolgvg0": "Please select the submenu to be added!",
        "5o6v4bolgxk0": "Only one submenu can be selected for editing!",
        "5o6v4bolgz10": "Tips",
        "5o6v4bolgz20": "Whether outer chain",
        "5o6v4bolgz30": "Whether customized report",
        "5o6v4bolgz40": "High risk category",
        "5o6v4bolgz50": "Button",
        "5o6v4bolgz60": "Other",
        "5o6v4bolgz70": "Please enter the menu code",
        "5o6v4bolg1w0": "Please enter the menu name",
        "5o6v4bolg2w0": "Please select type",
        "5o6v4bolg3w0": "Please select whether the resource is sensitive",
        "5o6v4bolg4w0": "Menu SN",
        "5o6v4bolg5w0": "This operation will deactivate the selected menu. Do you want to continue?",
        "5o6v4bolg6w0": "View context menu roles",
        "5o6v4bolg7w0": "Change resource parent node",
        "5o6v4bolg8w0": "Export menu resources",
        "5o6v4bolg9w0": "Add submenu",
        "5o6v4bol1zw0": "Deactivate menu",
        "5o6v3o41yxg0": "Import menu resources",
        "5o6v3o41zg00": "Assign menu role",
        "5o6v3o41zjo0": "Assigned menu role",
        "5o6v3o41zmg0": "Change the parent node",
        "5o6v3o41zp80": "Menu Resource",
        "5o6v3o41zs80": "Add Sub-Resource",
        "5o6v3o41zuw0": "Cannot delete root resource!",
        "5o6v3o41zxk0": "Click OK to delete this menu (and all its submenus)",
        "5o6v3o4200g0": "Are you sure to delete this menu",
        "5o6v3o420340": "Please select menu resource first",
        "5o6uyb93u4w0": "User group associated position",
        "5o6uyb93ukc0": "Please select user group first!",
        "5o6uyb93unw0": "Please select user group!",
        "5o6uyb93urg0": "Add",
        "5o6uyb93ux80": "View menu role",
        "5o6uyb93v000": "Menu",
        "5o6uyb93v2k0": "Data",
        "5o6uyb93v800": "View group members",
        "5o6uyb93vas0": "Set group members",
        "5o6uyb93vds0": "If there are no members under the user group and no menu roles or data permissions are bound, the user group can be deleted",
        "5o6uyb93vg40": "Sure to delete the user group",
        "5o6uyb93vi10": "OK",
        "5o6uyb93vi20": "Please enter user group code",
        "5o6uyb93vi30": "Please enter the user group name",
        "5o6uyb93vi40": "Data Role Code",
        "5o6uyb93vi50": "Data Role Name",
        "5o6uyb93vi60": "Click OK to delete",
        "5o6uut7refw0": "Select import type",
        "5o6uut7rf2w0": "Download import template",
        "5o6uut7rf780": "Upload template",
        "5o6uut7rfa00": "Import completed",
        "5o6uut7rfck0": "Quickly Import",
        "5o6uut7rffs0": "Import amount is less than 10000",
        "5o6uut7rfio0": "Mass import",
        "5o6uut7rfl40": "Import more than 10000 pieces of data",
        "5o6uut7rfnw0": "Tips: The file cannot exceed 20MB",
        "5o6uut7rfqk0": "Select",
        "5o6uut7rft00": "Download the Excel template, fill in and upload the Excel file.",
        "5o6uut7rfvs0": "Notes",
        "5o6uut7rfy00": "Drop files here",
        "5o6uut7rg0g0": "Click Upload",
        "5o6uut7rg300": "Back",
        "5o6uut7rg5g0": "Wait for the import results",
        "5o6uut7rg7w0": "Wait for the import result file to be imported. You can leave the interface to process other tasks",
        "5o6uut7rgac0": "Close",
        "5o6uut7rgcs0": "Parsing the file, please wait a moment",
        "5o6uut7rgfc0": "Import completed,",
        "5o6uut7rgiw0": "pieces of data imported successfully",
        "5o6uut7rgl80": "Download import results",
        "5o6uut7rgnw0": "Re-upload",
        "5o6uut7rgq80": "Tips: A file cannot exceed 20MB, please upload the excess in batches",
        "5o6uut7rgsc0": "Please remember to check",
        "5o6uut7rguc0": "The format is not supported",
        "5o6uut7rgwc0": "Tips: The file cannot exceed 10MB",
        "5o6uut7rgy40": "Parsing failed",
        "5o6uut7rh000": "Upload failed",
        "5o6uut7rh110": "1. Please fill in as required",
        "5o6uut7rh120": "2. The contents of the fields are not supported: spaces and placeholders. If they are included, the system will automatically filter the files after uploading;",
        "5o6uut7rh130": "3.If there are blank lines, they need to be deleted. ",
        "5o6uut7rh140": "Batch-adding Users",
        "5o6uut7rh1s0": "The size of the uploaded file exceeds 20MB, please check the file and upload again",
        "5o6upp1vnsg0": "Permission source",
        "5o6upp1vom80": "The user has access to the menu/button from the following channels. If you want to remove the user's access to the menu/button, you need to remove the users from the following channels",
        "5o6upp1vorc0": "Permission Source Type",
        "5o6upp1vouc0": "Details",
        "5o6upp1vows0": "View",
        "5o6upp1vp000": "Name",
        "5o6upp1vp2w0": "Code",
        "5o6upp1vp910": "Request Exception",
        "5o6upp1vp920": "User Group Code",
        "5o6upp1vp930": "User Group Name",
        "5o6upp1vp940": "Confirm Delete",
        "5o6upp1vp950": "Sure to delete the user",
        "5o6upp1vp960": "Sure to delete",
        "5o6upp1vp970": "Confirm to deactivate the user",
        "5o6upp1vp980": "After deactivation, the user will lose all permissions and cannot use the system normally",
        "5o6upp1vp990": "Confirm Unfreezing",
        "5o6upp1vp9w0": "Confirm Unfreezing",
        "5o6up3960fo0": "Menu Name",
        "5o6up3960k80": "Menu Code",
        "5o6umf8wpe40": "Data Type",
        "5o6umf8wq2o0": "Input",
        "5o6umf8wqfc0": "Data Code",
        "5o6umf8wqi10": "Operation Tips",
        "5o6umf8wqi20": "Warehouse Code",
        "5o6umf8wqi00": "Warehouse Name",
        "5o6uklwd1j00": "Created By",
        "5o6uklwd1mc0": "Created Time",
        "5o6uj7uysb00": "Software System",
        "5o6uj7uysto0": "Role Name",
        "5o6uj7uysxs0": "Role Code",
        "5o6uj7uyt780": "Sensitive or not",
        "5o6uj7uyta00": "No",
        "5o6uj7uytcs0": "Yes",
        "5o6uj7uytfo0": "Software System",
        "5o6uj7uytl10": "Organization Name",
        "5o6uj7uytlc0": "No",
        "5o6oshqka0w0": "Show All",
        "5o6trh9vltc0": "Name",
        "5o6trh9vmbs0": "Please enter keywords",
        "5o6trh9vmg00": "User Account Number",
        "5o6trh9vmiw0": "Account Name",
        "5o6trh9vmlw0": "User Status",
        "5o6trh9vmow0": "Enable",
        "5o6trh9vmrs0": "Disable",
        "5o6trh9vmuo0": "Organization Name",
        "5o6trh9vmxg0": "Account Type",
        "5o6trh9vn080": "Created Source",
        "5o6trh9vn2w0": "Created By",
        "5o6trh9vn600": "Select",
        "5o6trh9vn900": "Reset",
        "5o6trh9vnbs0": "Show More",
        "5o6trh9vnek0": "Show Less",
        "5o6trh9vnh40": "Implemented",
        "5o6trh9vnj10": "Get query parameters",
        "5o6trh9vnj20": "Command",
        "5o6trh9vnjs0": "Remarks 2",
        "5o6otz4p17k0": "Organization Name",
        "5o6otz4p1bo0": "Organization Full Name",
        "5o6otz4p1eg0": "Administrator Authority",
        "5o6otz4p1hc0": "Organization Code",
        "5o6otz4p1kc0": "Organization Leader",
        "5o6otz4p1n40": "Type",
        "5o6otz4p1ps0": "Source",
        "5o6otz4p1t00": "Created Time",
        "5o6otz4p1w00": "Remarks",
        "5o6u3frckt00": "View Menu Authority",
        "5o6u3frclb00": "View Data Authority",
        "5o6u3frclj40": "Import Users",
        "5o6u3frclm00": "Import Menu Role",
        "5o6u3frclp00": "Import Data Role",
        "5o6u3frclrw0": "Import Menu Authority",
        "5o6u3frclus0": "Import User Group",
        "5o6u3frcm0s0": "More Information",
        "5o6u3frcm3g0": "View Data Authority",
        "5o6u3frcm6w0": "View Menu Authority",
        "5o6u3frcm9o0": "View User Groups",
        "5o6u3frcmco0": "Delete",
        "5o6u3frcmfg0": "Disable User",
        "5o6u3frcmi80": "Enable Users",
        "5o6u3frcmlc0": "Export Users",
        "5o6u3frcmo40": "Account Unfreezing",
        "5o6u3frcmxc0": "Exit Batch-operation",
        "5o6u3frcncs0": "Status",
        "5o6u3frcno10": "Attribute",
        "5o6u3frcno20": "Add User",
        "5o6u3frcno30": "Assign Menu Roles",
        "5o6u3frcno40": "Assign Date Resources",
        "5o6u3frcno50": "Edit",
        "5o6u3frcno60": "Add Type",
        "5o6u3frcno70": "Password",
        "5o6u3frcno80": "Confirm Password",
        "5o6u3frcno90": "Mobile Number",
        "5o6u3frcn1k0": "E-mail",
        "5o6u3frcn3k0": "Search",
        "5o6u3frcn4k0": "Search Add",
        "5o6u3frcn5k0": "User Type",
        "5o6u3frcn6k0": "Average User",
        "5o6u3frcn7k0": "Administrators",
        "5o6u3frcn8k0": "Cancel",
        "5o6u3frcn9k0": "Save",
        "5o6u3frc1ok0": "Please enter the user account",
        "5o6u3frc2ok0": "The user account only supports Chinese, English, numbers, _, -",
        "5o6u3frc3ok0": "The user account length cannot exceed 50 characters",
        "5o6u3frc4ok0": "Please enter the name",
        "5o6u3frc5ok0": "Name length cannot exceed 80 characters",
        "5o6u3frc6ok0": "At least two or more combinations of letters, numbers and characters, with a length of 8-20 digits",
        "5o6u3frc7ok0": "Please enter the password again",
        "5o6u3frc8ok0": "Passwords does not match",
        "5o6u3frc9ok0": "Please enter your mobile number",
        "5o6u3fr2nok0": "Please enter E-mail",
        "5o6u3fr3nok0": "E-mail format error",
        "5o6u3fr4nok0": "The length should be less than 50 characters",
        "5o6u3fr5nok0": "Please select the department",
        "5o6u3fr6nok0": "Please select the user type",
        "5o6u3fr7nok0": "Please select the account type",
        "5o6u3fr8nok0": "Remarks can be up to 120 characters",
        "5o6u3f3cnok0": "Select",
        "5o6u3f4cnok0": "Input",
        "5o6u3f5cnok0": "Input",
        "5o6u3f6cnok0": "Required",
        "5o6u3f7cnok0": "Create an account",
        "5o6u3f8cnok0": "Add an existing account",
        "5o6u3f9cnok0": "Please enter the organization name",
        "5o6u3frcnok0": "Please select a user!"
    }
}
